import { ABORT_REASON_CODES, type AbortReasonCode } from '@chukua/common';

const LABELS: Record<AbortReasonCode, string> = {
  driver_timeout: 'Driver did not respond in time',
  pre_trip_failed: 'Truck failed its pre-trip check',
  customer_cancelled: 'Customer cancelled',
  container_not_released: 'Container not released',
  route_change: 'Route changed',
};

export function abortReasonLabel(code: AbortReasonCode): string {
  return LABELS[code];
}

/** The closed list from the API's schema, in its order; there is no endpoint to fetch it from. */
export const ABORT_REASON_OPTIONS = ABORT_REASON_CODES.map((code) => ({ value: code, label: LABELS[code] }));
